import axios from "axios";

const BASE_URL = "https://sms.brightechsoftware.com/api/v1/smsdata";

export const getDashboardStats = async (fromDate, toDate) => {
    const res = await axios.get(`${BASE_URL}/stats`, {
        params: {
            fromDate: fromDate || null,
            toDate: toDate || null,
        },
    });
    return res.data;
};